'use client';
import React from 'react';

import type { PublicClientApiKeys } from '@eliadmin/core/src/api/general/public-client-api-keys';
import HomecreditCalculator from '@eliadmin/core/src/components/product/detail/homecredit/homecredit-calculator';
import HomecreditLogo from '@eliadmin/core/src/components/product/detail/homecredit/homecredit-logo';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

interface ProductHomecreditCalculatorProps {
  homecredit: PublicClientApiKeys['homecredit'];
  // Price in minor currency units (e.g. cents)
  price: number;
}

export const ProductHomecreditCalculator: React.FC<ProductHomecreditCalculatorProps> = ({
  homecredit,
  price,
}) => {
  const { t } = useTranslations();

  if (!homecredit?.calculator_url || !homecredit.api_key) {
    return null;
  }

  const getCalculatorUrl = () => {
    const baseUrl = homecredit.calculator_url;
    const params = new URLSearchParams({
      productSetCode: homecredit.product_set_code!,
      price: (price * 100).toString(), // Convert to minor currency units (e.g. cents)
      downPayment: '0',
      apiKey: homecredit.api_key!,
      fixDownPayment: 'false',
    });

    return `${baseUrl}?${params.toString()}`;
  };

  const handleClick = () => {
    const url = getCalculatorUrl();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="ea-product-homecredit flex min-h-[52px] w-full items-center gap-3 rounded-[18px] border border-[#E2E4E7] bg-white px-4 py-2 text-left text-[#0F1012] transition-colors hover:border-[#9096A0] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012]"
    >
      <span className="h-7 w-5 shrink-0 text-[#6B7079]">
        <HomecreditCalculator width="100%" height="100%" />
      </span>
      <span className="dlz-body-s-medium min-w-0 flex-1">{t('text2169')}</span>
      <span className="h-5 w-[52px] shrink-0 text-[#4F545C]">
        <HomecreditLogo width="100%" height="100%" />
      </span>
    </button>
  );
};
